define( [
	"./hasOwn"
], function( hasOwn ) {
	"use strict";

	return hasOwn.toString;
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/var/fnToString.js
// module id = 47
// module chunks = 0